import { render, staticRenderFns } from "./FullscreenLayout.vue?vue&type=template&id=2464e905"
import script from "./FullscreenLayout.vue?vue&type=script&lang=js"
export * from "./FullscreenLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports